import React, { ReactElement, useEffect, useRef } from 'react'

type ModalProps = {
  isOpen: boolean
  children: React.ReactNode
  onClose: () => void
}

const Modal = ({ isOpen, onClose, children }: ModalProps): ReactElement => {
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return (): void => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, onClose])

  return (
    <>
      {isOpen && (
        <div className='modal-overlay'>
          <div className='modal' ref={modalRef}>
            <button className='close-button' onClick={onClose}>
              &times;
            </button>
            <div className='flex-align-vh'>{children}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default Modal
